import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
// import { FirebaseMessaging } from "@capacitor-firebase/messaging";
import { Geolocation } from "@capacitor/geolocation";
import { Capacitor } from "@capacitor/core";
// import { PushNotifications } from "@capacitor/push-notifications";
// import { LocalNotifications } from "@capacitor/local-notifications";
import { App as ap } from "@capacitor/app";
import { Preferences } from "@capacitor/preferences";
import { ThemeProvider } from "./components/ui/theme-provider";
import { Toaster } from "./components/ui/toaster";
// Sonner toasts (toast.success / toast.error from "sonner"). Mounted here
// in App.js because this is the real entry rendered by the app — the
// similarly-named routes/index.tsx is unused dead code. Without this
// mount the planner's "Start the task first…" toast had nowhere to
// render and the call silently no-op'd.
import { Toaster as SonnerToaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { Login } from "./pages/Login";
import { Register } from "./pages/Register";
import { Dashboard } from "./pages/Dashboard";
import { Employees } from "./pages/Employee/Employees";
import Attendance from "./pages/Attendance";
import { Leaves } from "./pages/Leaves";
// import { Tasks } from "./pages/Tasks";
import { JobPostings } from "./pages/JobPostings";
import { ProtectedRoute } from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import ChangePassword from "./pages/changepass";
import ForgotPassword from "./pages/forgotpassword.tsx";
// import ProcessPayrollPage from "./pages/payslips";
import BulkPayrollTable from "./pages/bulk_payroll";
import AddPayroll from "./pages/AddPayroll";
import { ScreenShot } from "./pages/ScreenShot";
import { ScreenRecording } from "./pages/ScreenRecording";
import LandingPage from "./components/LandingPage";
import Reports from "./pages/Reports";
import Payslips from "./pages/Payslips";
import AddOffice from "./pages/AddOffice";
import AddCompany from "./pages/AddCompany";
import PayrollRecord from "./pages/PayrollRecord";
import SalaryTaxDeclaration from "./pages/Payroll/SalaryTaxDeclaration";
import { ActivityList } from "./pages/ActivityList";
import ActivityDashboard from "./pages/ActivityDashboard";
// import { getFCMToken, messaging } from "./firebase";
import Documents from "./pages/Documents";
import AppDownloads from "./pages/AppDownloads";
import ActivityComparison from "./pages/ActivityComparison";
import ApprovalSettings from "./pages/ApprovalSettings";
import SettingsPage from './pages/Settings/SettingsPage';
import CalendarPage from "./pages/Calendar/Calendar";



// Task Management Imports - Fix these paths
// import Dashboardtask from "./pages/Dashboard/Dashboard";
import TaskDashboard from './pages/TaskDashboard/TaskDashboard';
import TaskList from "./pages/Task/TaskList";
import ClientPortal from "./pages/ClientPortal/ClientPortal";
import PartnerTaskDetail from "./pages/Task/PartnerTaskDetail";
import TaskDetail from "./pages/Task/TaskDetails";
import RecentlyDeleted from "./pages/Task/RecentlyDeleted";
import TaskCreate from "./pages/Task/TaskCreate";
import TaskCreatePage from "./pages/Task/TaskCreatePage";
import ClientsPage from "./pages/Client/ClientsPage";
import VendorsPage from "./pages/Vendor/VendorsPage";
import MyTasks from "./pages/MyTasks/MyTasks";
import TeamTasks from "./pages/TeamTasks/TeamTasks";
import Notifications from "./pages/Notifications/Notifications";
import TaskReports from "./pages/TaskReports";
import TodoPlanner from "./pages/Todo/TodoPlanner";
import TodoHistory from "./pages/Todo/TodoHistory";
import ProjectsPage from "./pages/Project/ProjectsPage";
import ProjectsRecentlyDeleted from "./pages/Project/ProjectsRecentlyDeleted";
import ProjectDetails from "./pages/Project/ProjectDetails";
import TeamVisibility from "./pages/TeamVisibility/TeamVisibility";
import EmployeeResignation from "./pages/Separation/EmployeeResignation";
import PrivacyPolicy from "./pages/Policies/Privacy";


// Separation Management Imports
import SeparationManagement from "./pages/Separation/SeparationManagement";
import ResignationList from "./components/separation/resignationlist";
import TerminationList from "./components/separation/terminationlist";
import ExitChecklist from "./components/separation/exitchecklist";


function App() {
  async function askLocationPermission() {
    if (!Capacitor.isNativePlatform()) {
      console.log("🌐 Web platform → skip location permission");
      return;
    }

    const perm = await Geolocation.requestPermissions();
    console.log("LOCATION PERMISSION:", perm);
  }

  useEffect(() => {
    askLocationPermission();
    // App open pe sab notifications clear + badge reset
    // LocalNotifications.removeAllDeliveredNotifications();
    // Ya badge plugin use karo (extra install)
    // Badge.set({ badge: 0 });
  }, []);

  // useEffect(() => {
  //   const supported = FirebaseMessaging.isSupported();
  //   console.log("Supported:", supported);
  //   FirebaseMessaging.requestPermission().then((result) => {
  //     if (result.granted) {
  //       console.log("✅ FCM Permission granted");
  //       getToken(); // Token generate + save
  //     }
  //   });
  // }, []);

  // useEffect(() => {
  //   const initFCM = async () => {
  //     if (!Capacitor.isNativePlatform()) {
  //       console.log("🌐 Web detected - FCM skip");
  //       return;
  //     }

  //     try {
  //       console.log("🔍 Checking permission...");

  //       const permission = await FirebaseMessaging.requestPermission();
  //       console.log("Permission result:", permission);

  //       if (permission.granted) {
  //         const token = await FirebaseMessaging.getToken();
  //         console.log("🔥 TOKEN:", token.token);

  //         await Preferences.set({
  //           key: "fcmtoken",
  //           value: token.token,
  //         });

  //         console.log("✅ Token saved");
  //       } else {
  //         console.log("❌ Permission denied");
  //       }
  //     } catch (err) {
  //       console.log("🚫 FCM ERROR:", err);
  //     }
  //   };

  //   initFCM();
  // }, []);

  // const getToken = async () => {
  //   const token = await getFCMToken();

  //   // 👈 Global store mein save
  //   localStorage.setItem("fcmtoken", token);
  //   await Preferences.set({
  //     key: "fcmtoken1",
  //     value: token,
  //   });
  // };

  // useEffect(() => {
  //   const initPush = async () => {
  //     let permStatus = await PushNotifications.checkPermissions();
  //     console.log("Permission status:", permStatus.receive);
  //     if (permStatus.receive === "prompt") {
  //       permStatus = await PushNotifications.requestPermissions();
  //     }

  //     if (permStatus.receive === "granted") {
  //       await PushNotifications.register();
  //     }
  //   };
  //   initPush();
  // }, []);

  // useEffect(() => {
  //   initNotifications();
  //   setupAppStateListener();
  // }, []);

  // const initNotifications = async () => {
  //   // Permission request
  //   await LocalNotifications.requestPermissions();

  //   // Test notification
  //   await LocalNotifications.schedule({
  //     notifications: [
  //       {
  //         title: "HR Payroll",
  //         body: "Auto attendance active! Don't swipe from Recent apps",
  //         id: 1,
  //         badge: 0,
  //         schedule: { at: new Date(Date.now() + 5000) }, // 5 sec बाद
  //         sound: true,
  //         ongoing: true, // notification swipe न हो
  //         smallIcon: "ic_stat_notification",
  //       },
  //     ],
  //   });
  // };

  // const setupAppStateListener = () => {
  //   ap.addListener("appStateChange", ({ isActive }) => {
  //     if (!isActive) {
  //       // App background → Reminder notification
  //       LocalNotifications.schedule({
  //         notifications: [
  //           {
  //             title: "⚠️ HR Payroll Warning",
  //             body: "Clock out detected! Please open app to continue attendance.",
  //             id: 999,
  //             schedule: { at: new Date(Date.now() + 2000) },
  //             ongoing: true,
  //             sound: true,
  //           },
  //         ],
  //       });
  //     }
  //   });
  // };

  return (
    <AuthProvider>
      <ThemeProvider defaultTheme="light" storageKey="ui-theme">
        <Router>
          <Routes>

            <Route path="/" element={<LandingPage />} index={true} replace />

            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Dashboard />
                  </Layout>
                </ProtectedRoute>
              }
            />
            {/* <Route path="/" element={<LandingPage />} /> */}
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Dashboard />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route
              path="/employees"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Employees />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/activity-list"
              element={
                <ProtectedRoute>
                  <Layout>
                    <ActivityList />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/activity-reports"
              element={
                <ProtectedRoute>
                  <Layout>
                    <ActivityDashboard />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/downloads"
              element={
                <ProtectedRoute>
                  <Layout>
                    <AppDownloads />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route path="/settings/:tab" element={
              <ProtectedRoute>
                <Layout>
                  <SettingsPage />
                </Layout>
              </ProtectedRoute>
            } />

            <Route
              path="/activity-comparison"
              element={
                <ProtectedRoute>
                  <Layout>
                    <ActivityComparison />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/leaves"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Leaves />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/company"
              element={
                //  <ProtectedRoute>
                <Layout>
                  <AddCompany />
                </Layout>
                // </ProtectedRoute>
              }
            />
            <Route
              path="/office"
              element={
                //  <ProtectedRoute>
                <Layout>
                  <AddOffice />
                </Layout>
                // </ProtectedRoute>
              }
            />
            <Route
              path="/attendance"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Attendance />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/tasks/dashboard"
              element={
                <ProtectedRoute>
                  <Layout>
                    <TaskDashboard />
                  </Layout>
                </ProtectedRoute>
              }
            />

            {/* Task Management - New Routes */}
            <Route
              path="/tasks/list"
              element={
                <ProtectedRoute>
                  <Layout>
                    <TaskList />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/client-portal"
              element={
                <ProtectedRoute>
                  <Layout>
                    <ClientPortal />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/partner-task/:id"
              element={
                <ProtectedRoute>
                  <Layout>
                    <PartnerTaskDetail />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/tasks/my-tasks"
              element={
                <ProtectedRoute>
                  <Layout>
                    <TaskList />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/tasks/team-tasks"
              element={
                <ProtectedRoute>
                  <Layout>
                    <TaskList />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/tasks/employee-tasks"
              element={
                <ProtectedRoute>
                  <Layout>
                    <TeamVisibility />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/tasks/reports"
              element={
                <ProtectedRoute>
                  <Layout>
                    <TaskReports />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/tasks/create"
              element={
                <ProtectedRoute>
                  <Layout>
                    <TaskCreatePage />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/tasks/recently-deleted"
              element={
                <ProtectedRoute>
                  <Layout>
                    <RecentlyDeleted />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/tasks/:taskId"
              element={
                <ProtectedRoute>
                  <Layout>
                    <TaskDetail />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/clients"
              element={
                <ProtectedRoute>
                  <Layout>
                    <ClientsPage />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/vendors"
              element={
                <ProtectedRoute>
                  <Layout>
                    <VendorsPage />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/projects"
              element={
                <ProtectedRoute>
                  <Layout>
                    <ProjectsPage />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/projects/recently-deleted"
              element={
                <ProtectedRoute>
                  <Layout>
                    <ProjectsRecentlyDeleted />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/projects/:id"
              element={
                <ProtectedRoute>
                  <Layout>
                    <ProjectDetails />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/tasks/notifications"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Notifications />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/todo"
              element={
                <ProtectedRoute>
                  <Layout>
                    <TodoPlanner />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/todo/history"
              element={
                <ProtectedRoute>
                  <Layout>
                    <TodoHistory />
                  </Layout>
                </ProtectedRoute>
              }
            />


            {/* Separation Management Routes */}
            <Route
              path="/separation/dashboard"
              element={
                <ProtectedRoute>
                  <Layout>
                    <SeparationManagement />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/separation/resignations"
              element={
                <ProtectedRoute>
                  <Layout>
                    <SeparationManagement />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/separation/terminations"
              element={
                <ProtectedRoute>
                  <Layout>
                    <SeparationManagement />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/separation/checklists"
              element={
                <ProtectedRoute>
                  <Layout>
                    <SeparationManagement />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/separation/settlements"
              element={
                <ProtectedRoute>
                  <Layout>
                    <SeparationManagement />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/my-resignation"
              element={
                <ProtectedRoute>
                  <Layout>
                    <EmployeeResignation />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/documents"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Documents />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/jobs"
              element={
                <ProtectedRoute>
                  <Layout>
                    <JobPostings />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/Payslips"
              element={
                <Layout>
                  <Payslips />
                </Layout>
              }
            />
            <Route
              path="/payroll-record"
              element={
                <ProtectedRoute>
                  <Layout>
                    <PayrollRecord />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/salary-tax-declaration"
              element={
                <ProtectedRoute>
                  <Layout>
                    <SalaryTaxDeclaration />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/approval-settings"
              element={
                <ProtectedRoute>
                  <Layout>
                    <ApprovalSettings />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/screen-shot"
              element={
                 <ProtectedRoute>
                <Layout>
                  <ScreenShot />
                </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/screen-recording"
              element={
                 <ProtectedRoute>
                <Layout>
                  <ScreenRecording />
                </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/AddPayroll"
              element={
                <Layout>
                  <AddPayroll />
                </Layout>
              }
            />

            {/* <Route path="/change-password" element={<ChangePassword />} /> */}
            <Route path="/forgot-password" element={<ForgotPassword />} />

            {/* // <Route path="/payroll/records" element={<PayrollRecords />} />
            // <Route path="/payroll/payslips" element={<Payslips />} />
            // <Route path="/payroll/tds" element={<TDS />} />
            // <Route path="/payroll/reports" element={<Reports />} />  */}

            <Route
              path="/reports"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Reports />
                  </Layout>
                </ProtectedRoute>
              }
            />

            <Route
              path="/calendar"
              element={
                <ProtectedRoute>
                  <Layout>
                    <CalendarPage />
                  </Layout>
                </ProtectedRoute>
              }
            />
          </Routes>
          {/* Toaster lives INSIDE <Router> so its DismissOnNavigate child
              can subscribe to location changes and auto-close popups when
              the user leaves the current page. */}
          <Toaster />
          {/* Sonner toasts — used by TodoPlanner, Checklist, RecentlyDeleted,
              QuickAdd, useReminderStream via `import { toast } from "sonner"`.
              Without this mount every `toast.success / toast.error` call from
              those modules is silently dropped (Sonner needs its own
              Toaster). top-right + richColors so errors show with a red
              background and successes with a green one. */}
          <SonnerToaster position="top-right" richColors closeButton />
        </Router>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
